import { useInfiniteQuery } from '@tanstack/react-query'

import { sharesServices } from '../sharesServices'
import { FetchAllStocksParams } from '../sharesTypes'

import { QUERY_KEYS } from '@/constants/queryKeys'

export const useFetchMyStocks = (params: FetchAllStocksParams) =>
  useInfiniteQuery({
    initialPageParam: 0,
    queryKey: [QUERY_KEYS.SHARES_MY_STOCKS, params],
    queryFn: ({ pageParam }) =>
      sharesServices.fetchMyStocks({ ...params, page_id: pageParam }),
    getNextPageParam: (lastPage) => lastPage.next_page_id || null,
    select: (data) => ({
      ...data,
      pages: data.pages.flatMap((page) => page.stocks),
    }),
    staleTime: 60 * 5 * 1000,
  })
